module.exports = __webpack_public_path__ + "img/title04.f2f687ec.png";